import * as React from "react";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import { Grid } from "semantic-ui-react";
import * as routes from "../../constants/routes";
import { firebaselogin } from "../../firebase/firebaselogin";
import { withAuthentication } from "../Session/withAuthentication";
import { SemanticToastContainer } from "react-semantic-toasts";
import Datasources from "src/containers/Datasources";
import NewDatasource from "src/containers/Datasources/new";
import Account from "src/containers/Account";
import Landing from "src/containers/Landing";
import SignIn from "src/containers/SignIn";
import Dashboards from "src/containers/Dashboards";
import Dashboard from "src/containers/Dashboards/Dashboard";
import NewOrganization from "src/containers/Organizations/new";
import Organizations from "src/containers/Organizations";
import Error from "src/containers/Error";
import ManageUsers from "src/containers/ManageUsers";
import Join from "src/containers/Join";
import Analyses from "../../containers/Analyses";
import Analysis from "../../containers/Analysis";

class AppComponent extends React.Component {
  constructor(props: any) {
    super(props);

    this.state = {
      authUser: null,
    };
  }

  public componentDidMount() {
    firebaselogin.auth().onAuthStateChanged((authUser: firebase.User) => {
      authUser
        ? this.setState(() => ({ authUser }))
        : this.setState(() => ({ authUser: null }));
    });
  }

  public render() {
    return (
      <BrowserRouter>
        <Grid columns="equal" className="app">
          <Grid.Column style={{ paddingBottom: "0px" }}>
            <Switch>
              {/** Non Auth Routes */}
              <Route exact={true} path={routes.LANDING} component={Landing} />
              <Route exact={true} path={routes.SIGN_IN} component={SignIn} />
              {/** Auth Routes */}
              {/** Analysis Routes */}
              <Route
                exact={true}
                path={routes.ANALYSES_ROUTE}
                component={Analyses}
              />
              <Route exact={true} path={routes.QUERY} component={Analysis} />
              <Route
                exact={true}
                path={routes.ANALYSIS_ROUTE}
                component={Analysis}
              />
              {/** Datasource Routes */}
              <Route
                exact={true}
                path={routes.NEW_DATASOURCE_ROUTE}
                component={NewDatasource}
              />
              <Route
                exact={true}
                path={routes.DATASOURCES_ROUTE}
                component={Datasources}
              />
              {/** Dashboard Routes */}
              <Route
                exact={true}
                path={routes.DASHBOARD_ROUTE}
                component={Dashboard}
              />
              <Route
                exact={true}
                path={routes.NEW_DASHBOARD_ROUTE}
                component={NewDatasource}
              />
              <Route
                exact={true}
                path={routes.DASHBOARDS_ROUTE}
                component={Dashboards}
              />
              {/** Organization Routes */}
              <Route
                path={routes.NEW_ORGANIZATION}
                component={NewOrganization}
              />
              <Route path={routes.ORGANIZATIONS} component={Organizations} />
              {/** Administration Routes */}
              <Route path={routes.MANAGE_USERS_ROUTE} component={ManageUsers} />
              <Route path={routes.JOIN_ROUTE} component={Join} />

              {/** Other Routes */}
              <Route exact={true} path={routes.ERROR} component={Error} />
              <Route exact={true} path="/" component={Organizations} />
              <Route exact={true} path={routes.ACCOUNT} component={Account} />
              <Route component={Error} />
            </Switch>
          </Grid.Column>
        </Grid>
        <SemanticToastContainer position="bottom-right" />
      </BrowserRouter>
    );
  }
}

export const App = withAuthentication(AppComponent);



// WEBPACK FOOTER //
// ./src/components/App/index.tsx